import { createContext, useContext } from 'react';

/** DOM node Radix portals should mount into so they stay inside .admin-portal. */
export const AdminPortalContext = createContext<HTMLElement | null>(null);

export function useAdminPortalContainer() {
  return useContext(AdminPortalContext);
}
